import { InviteProgramStatusEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function inviteProgramStatusNameFilter(type: InviteProgramStatusEnum): string {
    switch(type) {
        case InviteProgramStatusEnum.Upcome: return i18n.t(LF.Upcome) as string;
        case InviteProgramStatusEnum.Active: return i18n.t(LF.Active) as string;
        case InviteProgramStatusEnum.Finished: return i18n.t(LF.Finished) as string;
    }
}